import axios from "axios";
import { resetProfile } from "../data/redux/slices/ProfileSlice";
import { clearContactsCache } from "../data/redux/slices/ContactSlice";
import { useDispatch } from "react-redux";
let store;
export const injectStore = (_store) => {
  store = _store;
};

const baseURL = "https://nf6fp9tcn6.execute-api.eu-north-1.amazonaws.com/"
  // process.env.NODE_ENV === "production"
  //   ? "https://nf6fp9tcn6.execute-api.eu-north-1.amazonaws.com/"
  //   : "http://localhost:4004/";

const api = axios.create({ baseURL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
 localStorage.removeItem("userId");
      localStorage.removeItem("token");
        if (store) {
        store.dispatch(resetProfile());
        store.dispatch(clearContactsCache());
      }

   
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;